import PropTypes from 'prop-types';

import Stack from '@mui/material/Stack';

import Logo from 'src/components/full-logo';

// ----------------------------------------------------------------------

export default function AuthClassicLayout({ children, image, title }) {
  const renderLogo = (
    <Logo
      sx={{
        zIndex: 9,
        position: 'absolute',
        my: { xs: 2, md: 5 },
        mx: 2,
      }}
    />
  );

  const renderContent = (
    <Stack
      flexGrow={1}
      alignItems="center"
      justifyContent="center"
      minWidth="460px"
      sx={{ py: 15 }}
    >
      {children}
    </Stack>
  );

  return (
    <Stack
      component="main"
      direction="row"
      sx={{
        minHeight: '100vh',
        px: { xs: 2, md: 5 },
      }}
      spacing={5}
    >
      {renderLogo}

      {renderContent}
    </Stack>
  );
}

AuthClassicLayout.propTypes = {
  children: PropTypes.node.isRequired,
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};
